import {
    besoinsLogementSociaux,
    caracteristiqueSocioDemographique,
    financement,
    localisation,
    dynamisme,
    loyersLogementPLUSPLAI,
    parcSocial,
} from "./InterfaceTerritoire";

import ficheClass from "./classFiche";

//import data from './prototypeDataTerritoire';
import * as _ from "lodash";

const column = ["DE", "AT", "PA", "ON"];

export default class territoireClass extends ficheClass {
    besoinsLogementSociaux = new besoinsLogementSociaux();
    caracteristiqueSocioDemographique = new caracteristiqueSocioDemographique();
    parcSocial = new parcSocial();
    dynamisme = new dynamisme();

    calcCaracteristiqueTerritoire(data: any, subKey: string) {
        // Faire de même avec département
        if (this.year === "2017") {
            this.caracteristiqueSocioDemographique.croissanceDemo =
                data?.caractSocioDemographique?.croissanceDemo?.PA?.tx;
            this.caracteristiqueSocioDemographique.chomeur[subKey] =
                Number(data?.caractSocioDemographique?.chomeur?.PA?.nb) /
                Number(data?.caractSocioDemographique?.actif?.PA?.nb);
            this.caracteristiqueSocioDemographique.pauvrete[subKey] =
                data?.caractSocioDemographique?.pauvrete?.PA?.tx;
            this.caracteristiqueSocioDemographique.RUC2eDecile[subKey] =
                data?.caractSocioDemographique?.RUC2eDecile?.PA?.euros;
        } else {
            this.caracteristiqueSocioDemographique.croissanceDemo[subKey] =
                (
                    ((Number(data?.localisation?.habitant?.PA?.nb) -
                        Number(data?.localisation?.habitant?.PA2012?.nb)) /
                        Number(data?.localisation?.habitant?.PA2012?.nb)) *
                    100
                )
                    .toFixed(2)
                    .toString() + "%";

            this.caracteristiqueSocioDemographique.chomeur[subKey] =
                Number(data?.caractSocioDemographique?.chomeur?.PA?.nb) /
                Number(data?.caractSocioDemographique?.actif?.PA?.nb);

            this.caracteristiqueSocioDemographique.pauvrete[subKey] =
                Number(data?.caractSocioDemographique?.pauvrete?.PA?.nb) /
                Number(data?.localisation?.habitant1?.PA?.nb);
            this.caracteristiqueSocioDemographique.RUC2eDecile[subKey] =
                (
                    Number(data?.mediane?.niveaudevie?.nb) /
                    Number(data?.localisation?.habitant2?.PA?.nb)
                )
                    .toFixed(0)
                    .toString() + "€";
            //data?.caractSocioDemographique?.RUC2eDecile?.PA?.euros;
        }

        this.dynamisme.construNeuve[subKey] =
            data?.dynamisme?.construNeuve?.PA?.nb;
        this.dynamisme.construNeuvePourMille[subKey] =
            (Number(data?.dynamisme?.construNeuvePourMille?.PA?.nb) / Number(data?.localisation?.habitant3?.PA?.nb)).toFixed(0);
        if (this.year === "2017") {
            this.dynamisme.loyerMarche[subKey] =
                data?.dynamisme?.loyerMarche?.PA?.euros;
        } else if (subKey !== "DEPARTEMENT") {
            this.dynamisme.loyerMarche[subKey] = (
                data?.dynamisme?.loyerMarche?.PA?.euros /
                Number(data?.localisation?.resiPrincipale?.PA?.nb)
            ).toFixed(2);
        }
        this.dynamisme.vacancePrive[subKey] =
            data?.dynamisme?.vacancePrive?.PA?.tx;

        this.parcSocial.logementSociaux[subKey] =
            data?.caracteristiqueHlm?.nombre?.PA?.nb; // A creer
        this.parcSocial.logementSociauxTaux[subKey] =
            Number(data?.caracteristiqueHlm?.nombre?.PA?.nb) /
            Number(data?.localisation?.resiPrincipale?.PA?.nb); // A creer
        this.parcSocial.logementSociauxQPV[subKey] =
            data?.caracteristiqueHlm?.nombreQPV?.PA?.nb; // A creer
        this.parcSocial.logementSociauxQPVTaux[subKey] =
            Number(data?.caracteristiqueHlm?.nombreQPV?.PA?.nb) /
            Number(data?.caracteristiqueHlm?.nombre?.PA?.nb); // A creer
        this.parcSocial.bailleur[subKey] = data?.parcSocial?.bailleur?.PA?.nb; // A creer
        this.parcSocial.bailleurSup50[subKey] =
            data?.parcSocial?.bailleurSup50?.PA?.nb; // A creer
        if ("TERRITOIRE" == subKey) {
            if (this.year === "2017") {
                this.parcSocial.revenuPremierQuartile[subKey] =
                    data?.parcSocial?.revenuPremierQuartile?.AT?.euros; // A creer
            } else {
                this.parcSocial.revenuPremierQuartile[subKey] =
                    (
                        data?.parcSocial?.revenuPremierQuartile?.AT?.euros /
                        data?.nbTown
                    )
                        .toFixed(0)
                        .toString() + "€";
            }
        }

        this.besoinsLogementSociaux.nbDemandeRapportAttribution[subKey] =
            Math.floor(
                (Number(data?.caracteristiqueHlm?.nombre?.DE?.nb) /
                    Number(data?.caracteristiqueHlm?.nombre?.ATRPLS?.nb)) *
                    10
            ) / 10;
        this.besoinsLogementSociaux.mutation[subKey] = null; // Pas de données
        this.besoinsLogementSociaux.nombreLogementLivre[subKey] =
            data?.caracteristiqueHlm?.nombre?.ON?.nb;
        this.besoinsLogementSociaux.tauxCroissance[subKey] =
            data?.caracteristiqueHlm?.nombre?.ON?.nb /
            data?.caracteristiqueHlm?.nombre?.PA?.nb;
        this.besoinsLogementSociaux.besoinsLogementSociaux[subKey] =
            data?.besoinsLogementSociaux?.SRUlgtAProduire?.PA?.nb;

        if (!_.isNil(data?.besoinsLogementSociaux?.lgtSociauxVacants)) {
            if (this.year === "2017") {
                this.besoinsLogementSociaux.lgtSociauxVacants[subKey] =
                    data?.besoinsLogementSociaux?.lgtSociauxVacants?.PA?.tx;
            } else {
                this.besoinsLogementSociaux.lgtSociauxVacants[subKey] =
                    (
                        (data.financement?.nonReserve?.PA?.nb /
                            data.caracteristiqueHlm?.nombre?.PA?.nb) *
                        100
                    )
                        .toFixed(1)
                        .toString() + "%";
            }
            //} 1else {
            //    data.1besoinsLogementSociaux.lgtSociauxVacants[subKey] = null;
        }
        1;
    }

    constructor(
        data: any,
        dataDepartement: any,
        dataEPCI: any,
        dataCommune: any
    ) {
        super(data);

        this.localisation.tableRegion.nom = "Rhône-Alpes";
        this.localisation.tableRegion.nbHabitant = 6449000;
        this.localisation.tableRegion.resiPrincipale = 2590559;

        if (dataDepartement) {
            this.localisation.tableDepartement.nom =
                dataDepartement.localisation?.departement;
            this.localisation.tableDepartement.nbHabitant =
                dataDepartement.localisation?.habitant?.PA?.nb;
            this.localisation.tableDepartement.nbHabitantRatio =
                Number(this.localisation?.tableDepartement?.nbHabitant) /
                Number(this.localisation?.tableRegion.nbHabitant);
            this.localisation.tableDepartement.resiPrincipale =
                dataDepartement.localisation?.resiPrincipale?.PA?.nb;
            this.localisation.tableDepartement.resiPrincipaleRatio =
                Number(this.localisation?.tableDepartement?.resiPrincipale) /
                Number(this.localisation?.tableRegion.resiPrincipale);
        }

        if (dataEPCI) {
            this.localisation.tableEpci.nom = dataEPCI.localisation?.EPCI;
            this.localisation.tableEpci.nbHabitant =
                dataEPCI.localisation?.habitant?.PA?.nb;
            this.localisation.tableEpci.nbHabitantRatio =
                Number(this.localisation?.tableEpci.nbHabitant) /
                Number(this.localisation?.tableDepartement?.nbHabitant);
            this.localisation.tableEpci.resiPrincipale =
                dataEPCI.localisation?.resiPrincipale?.PA?.nb;
            this.localisation.tableEpci.resiPrincipaleRatio =
                Number(this.localisation?.tableEpci.resiPrincipale) /
                Number(this.localisation?.tableDepartement?.resiPrincipale);
        }

        if (dataCommune) {
            this.localisation.tableCommune.nom =
                dataCommune.localisation?.commune;
            this.localisation.tableCommune.nbHabitant =
                dataCommune.localisation?.habitant?.PA?.nb;
            this.localisation.tableCommune.nbHabitantRatio =
                Number(this.localisation?.tableCommune?.nbHabitant) /
                Number(this.localisation?.tableEpci?.nbHabitant);
            this.localisation.tableCommune.resiPrincipale =
                dataCommune.localisation?.resiPrincipale?.PA?.nb;
            this.localisation.tableCommune.resiPrincipaleRatio =
                Number(this.localisation?.tableCommune?.resiPrincipale) /
                Number(this.localisation?.tableEpci?.nbHabitant);
        }

        //Todo attendre
        this.calcCaracteristiqueTerritoire(data, "TERRITOIRE");
        this.calcCaracteristiqueTerritoire(dataDepartement, "DEPARTEMENT");
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/classTerritoire.ts